<template>
  <section class="report-list">
    <div>
      <div class="level">
        <div class="level-left">
          <h2>Reports ({{ totalRecords }})</h2>
        </div>
        <div class="level-right">
          <b-dropdown
            aria-role="list"
            max-height="200"
            :v-model="sortOption"
            trap-focus
            @change="sortReports"
          >
            <template #trigger="{ active }">
              <a class="navbar-item">
                <span>{{ sortOption.value }}</span>
                <b-icon v-if="active" icon="menu-up"></b-icon>
                <b-icon v-else icon="menu-down"></b-icon>
              </a>
            </template>
            <b-dropdown-item
              v-for="(menu, index) in sortMenu"
              :key="index"
              :value="menu"
              aria-role="listitem"
            >
              {{ menu.value }}
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
    </div>

    <div
      class="card is-dashboard-list dashboard-reports"
      :class="{ CustomerView: !hideCustomerView }"
    >
      <b-notification :closable="false">
        <ul class="card-content">
          <div
            class="has-text-grey has-text-centered"
            v-if="records.length == 0 && !isLoading"
          >
            <p>
              <b-icon icon="file-document-outline" size="is-large" />
            </p>
            <p>No Reports to show&hellip;</p>
          </div>
          <div
            class="item-container"
            v-for="(row, index) in records"
            :key="index"
          >
            <li>
              <article class="media">
                <figure class="media-left">
                  <country-flag :country="row.country_code" size="normal" />
                </figure>
                <div class="media-content">
                  <div class="customer-name">
                    <span> {{ row.customer_name }} </span>

                    <br />
                    <span>
                      {{ row.country_code }} / {{ row.stream_name }} /
                      {{ row.scheme_name }} / {{ row.period }}
                    </span>
                    <br />
                    <a
                      style="text-decoration: underline"
                      @click.prevent="openReport(row)"
                      ><span>{{ row.r_id }}</span>
                    </a>
                  </div>
                </div>

                <div class="media-right">
                  <div v-if="row.overdue_status === true">
                    <div
                      class="details is-danger"
                      v-if="row.revised_scheme_deadline !== null"
                    >
                      {{ row.revised_scheme_deadline }}<br />
                      {{ row.status }}
                    </div>
                    <div class="details is-danger" v-else>
                      {{ row.planned_scheme_deadline }}<br />
                      {{ row.status }}
                    </div>
                  </div>
                  <div v-else-if="row.due_status === true">
                    <div class="details is-warning">
                      {{ row.planned_scheme_deadline }}<br />
                      {{ row.status }}
                    </div>
                  </div>
                  <div v-else>
                    <div class="details">
                      {{ row.planned_scheme_deadline }}<br />
                      {{ row.status }}
                    </div>
                  </div>
                </div>
              </article>
              <hr />
            </li>
          </div>
        </ul>
        <b-loading
          :is-full-page="false"
          v-model="isLoading"
          :can-cancel="true"
        ></b-loading>
      </b-notification>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { Permission } from "../../services/Permissions";
import DashboardDataService from "../../services/DashboardDataService";
import { UserGroup } from "../../services/UserGroups";
import UtilityMixin from "@/mixins/UtilityMixin";
// @group Dashboard
export default {
  name: "ReportList",
  mixins: [UtilityMixin],
  props: {
    defaultView: {
      type: Boolean
    },
    hideCustomerView: {
      type: Boolean,
      default: true
    },
    allUserMap: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      dashboardDataService: new DashboardDataService(),
      records: [],
      isLoading: false,
      userMap: this.allUserMap,
      enableLoadMore: false,
      scrollheight: 0,
      totalRecords: 0,
      query: "",
      nextPageCursor: "",
      switchCustomerId: null,
      defaultVeiwChanged: false,
      sortOption: { id: "planned_scheme_deadline", value: "Sort by Due Date" },
      sortMenu: [
        { id: "planned_scheme_deadline", value: "Sort by Due Date" },
        { id: "status", value: "Sort by Status" },
        { id: "customer_name", value: "Sort by Customer Name" }
      ]
    };
  },
  computed: {
    ...mapGetters(["userId", "userName", "userHasPermission", "userGroups"]),
    isUserAdminOrCAM() {
      if (
        this.userGroups.includes(UserGroup.EPR_ADMIN) ||
        this.userGroups.includes(UserGroup.CUSTOMER_ACCOUNT_MANAGER)
      ) {
        return true;
      }
      return false;
    }
  },
  watch: {
    defaultView(newVal) {
      this.defaultVeiwChanged = true;
      if (Object.keys(this.userMap).length > 0) {
        this.fetchIncompleteReportTracker();
      }
    },
    allUserMap(newVal) {
      this.userMap = newVal;
      this.fetchIncompleteReportTracker();
    }
  },
  mounted() {
    const listElm = document.querySelector(".dashboard-reports");

    listElm.addEventListener("scroll", e => {
      if (
        this.enableLoadMore &&
        Math.round(listElm.scrollTop) + Math.round(listElm.clientHeight) >=
          Math.round(listElm.scrollHeight * 0.9) &&
        this.scrollheight != Math.round(listElm.scrollHeight)
      ) {
        this.scrollheight = Math.round(listElm.scrollHeight);
        this.pullNextPage();
      }
    });
    const switchCustomerData = this.fetchSwitchCustomerCache();
    if (switchCustomerData != null) {
      this.switchCustomerId = switchCustomerData["switchCustomerNumber"];
    }
    //this.fetchIncompleteReportTracker();
  },
  methods: {
    getUniqueListBy(arr, key) {
      return [...new Map(arr.map(item => [item[key], item])).values()];
    },
    prepareReportsData(data) {
      for (const idx in data) {
        const reportData = data[idx];
        if (reportData == null || reportData == undefined) {
          reportData["reporting_responsible"] = "None";
        } else {
          reportData["reporting_responsible_id"] =
            reportData["reporting_responsible"];
          reportData["reporting_responsible"] = this.allUserMap[
            reportData["reporting_responsible"]
          ];
        }
        data[idx] = reportData;
      }

      return data;
    },
    fetchIncompleteReportTracker(sortBy = this.sortOption.id) {
      this.isLoading = true;
      const reportStatusObserve = this.dashboardDataService.getIncompleteReportTracker(
        sortBy,
        this.defaultView,
        this.switchCustomerId,
        this.query
      );
      reportStatusObserve.subscribe(
        response => {
          this.nextPageCursor = response["next"]
            ? "&page=" + response["next"].split("&page=")[1]
            : null;
          this.totalRecords = response.count;
          if (this.defaultVeiwChanged) {
            this.records = [];
            this.defaultVeiwChanged = false;
          }
          this.records.push(...this.prepareReportsData(response.results));
          //this.records = this.getUniqueListBy(this.records, "id");
          if (this.nextPageCursor != null) {
            this.enableLoadMore = true;
          } else {
            this.enableLoadMore = false;
          }
          this.isLoading = false;
        },
        e => {
          console.log(e);
          this.isLoading = false;
        }
      );
      return reportStatusObserve;
    },

    sortReports(option) {
      this.records = [];
      this.nextPageCursor = null;
      this.query = this.query.replace(/page=[0-9.]{1,2}&/g, "");
      this.sortOption = option;
      this.fetchIncompleteReportTracker(option.id);
    },

    pullNextPage() {
      if (this.nextPageCursor != null || this.nextPageCursor != undefined) {
        this.query = this.nextPageCursor;
        this.nextPageCursor != this.PreviousPageCursor
          ? this.fetchIncompleteReportTracker()
          : "";
      }
    },

    openReport(data) {
      // Based on user permission report will open in either edit or view modes
      let isEdit = false;
      if (
        this.userHasPermission(Permission.RTRACKER_REPORT_ASSIGN_ALL) &&
        data.active == true
      ) {
        isEdit = true;
      } else if (
        data.active == true &&
        this.userHasPermission(Permission.RTRACKER_REPORT_CHANGE_OWN) &&
        (data.customer_account_manager_id == this.userId ||
          data.reporting_responsible_id == this.userId)
      ) {
        isEdit = true;
      } else {
        isEdit = false;
      }
      if (isEdit == true) {
        const route = this.$router.resolve({
          name: "reportingtracker.edit",
          params: { id: data.id }
        });
        window.open(route.href, "_blank");
      } else {
        const route = this.$router.resolve({
          name: "reportingtracker.view",
          params: { id: data.id }
        });
        window.open(route.href, "_blank");
      }
    }
  }
};
</script>
